import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { FaChevronLeft } from 'react-icons/fa';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useHistory } from "react-router-dom";

import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay";
// import DeleteOverlay from '../../../components/overlays/DeleteOverlay';
import AllRulesModal from "../../UserComponents/modals/AllRulesModal";

import { GetAllRulesAction } from "../../../redux/actions/gameRulesAction.js";
import { isValidEmail } from "../../utils/helper.js";
import {
  editTeam,
  getOneTeam,
  deleteTeam,
} from "../../services/team.services.js";
import {
  SELECTED_TEAM,
  UpdateSelectedTeam,
} from "../../../redux/actions/teamActions.js";

const initialState = {
  teamId: "",
  teamName: "",
  teamNickName: "",
  teamColor: "",
  gameRules: "",
  coachName: "",
  coachCell: "",
  coachEmail: "",
};

const EditTeam = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const operatorTeam = useSelector((state) => state.team.selectedTeam);

  const allRules = useSelector((state) => state.gameRules.allRules);

  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [groupModal, setGroupModal] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);
  const [displayPhone, setDisplayPhone] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const [error, setError] = useState(null);
  const [getTeamLoading, setGetTeamLoading] = useState(false);
  const [updateTeamLoader, setUpdateTeamLoader] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [delSuccessVisible, setDelSuccessVisible] = useState(false);

  const toggleDelete = () => {
    setDeleteVisible(!deleteVisible);
  };

  const toggleDelSuccessModal = () => {
    setDeleteVisible(false);
    setDelSuccessVisible(!delSuccessVisible);
    setTimeout(() => {
      history.push("/selectteam");
      setDelSuccessVisible(false);
    }, 2500);
  };

  const toggleSuccessModal = () => {
    setSuccessVisible(!successVisible);
    setTimeout(() => {
      history.push("/myteam");
      setSuccessVisible(false);
    }, 2500);
  };

  const goBackHandler = () => {
    history.goBack();
  };

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const toggleGroupModal = () => {
    setGroupModal(!groupModal);
  };

  const handleSelectGroup = (val) => {
    setSelectedRule(val);
    handleFormChange("gameRules", val._id);
    setGroupModal(false);
  };

  // Fetch team data
  useEffect(() => {
    (async () => {
      try {
        setGetTeamLoading(true);
        let response = await getOneTeam(operatorTeam?.teamId._id, user?.token);
        handleFormChange("teamId", response.data._id);
        handleFormChange("teamName", response.data.teamName);
        handleFormChange("teamNickName", response.data.teamNickName);
        handleFormChange("teamColor", response.data.teamColor);
        handleFormChange("coachCell", response.data.coachCell);
        handleFormChange("coachEmail", response.data.coachEmail);
        handleFormChange("coachName", response.data.coachName);
        handleFormChange("gameRules", response.data.gameRules);
      } catch (e) {
        console.log("Err at getOneTeam", e);
      } finally {
        setGetTeamLoading(false);
      }
    })();
  }, [operatorTeam, user?.token]);

  // tid
  useEffect(() => {
    dispatch(GetAllRulesAction(user?.token));
    handleFormChange("teamId", operatorTeam?.teamId._id);
  }, [dispatch, user?.token, operatorTeam?.teamId._id]);
  // phoneLength
  useEffect(() => {
    let phoneLength = initialStateForm.coachCell.length;
    let formattedNumber = "";

    if (phoneLength < 4) {
      // return initialStateForm.phone;
      formattedNumber = initialStateForm.coachCell;
    } else {
      if (phoneLength > 3 && phoneLength < 7) {
        formattedNumber = `(${initialStateForm.coachCell
          .toString()
          .slice(0, 3)}) ${initialStateForm.coachCell.toString().slice(3)}`;
      } else {
        formattedNumber = `(${initialStateForm.coachCell
          .toString()
          .slice(0, 3)}) ${initialStateForm.coachCell
          .toString()
          .slice(3, 6)}-${initialStateForm.coachCell.toString().slice(6, 12)}`;
      }
    }

    setDisplayPhone(formattedNumber);
  }, [initialStateForm.coachCell]);

  const handleUpdate = async () => {
    let emailLength = initialStateForm.coachEmail.length;
    try {
      if (emailLength > 0 && !isValidEmail(initialStateForm.coachEmail)) {
        throw new Error("Invaid email format!");
      }
      setUpdateTeamLoader(true);
      const response = await editTeam(initialStateForm, user?.token);
      toggleSuccessModal();
      dispatch(UpdateSelectedTeam(operatorTeam?._id));
    } catch (e) {
      setError(e);
      console.log("Error at EDIT LICENSE team ===>", e.response.data);
    } finally {
      setUpdateTeamLoader(false);
    }
  };
  const handleDeleteTeam = async () => {
    try {
      setLoading(true);
      const response = await deleteTeam(operatorTeam?.teamId._id, user?.token);
      toggleDelSuccessModal();
      dispatch({
        type: SELECTED_TEAM,
        payload: null,
      });
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  
  return (
    <div style={styles.container}>
      {/* Error Overlay */}
      <ErrorOverlay
        onBackdropPress={() => setError(null)}
        visible={!!error}
        error={error}
      />

<div className="backBtn">
        <button
          className="actionButtonBack"
          onClick={goBack}
        >
          &larr;
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.imgHeader}>
          <h1 style={styles.headerTxt}>EDIT TEAM</h1>

          <button onClick={handleDeleteTeam} style={styles.deleteBtn}>
            <DeleteOutlineIcon sx={{ fontSize: 35, color: "white" }} />
          </button>
        </div>

        {/* Form Fields */}
        <div style={styles.formContainer}>
          <div style={styles.nameInputRow}>
            <label style={styles.nameTxt}>Team Name:</label>
            <input
              placeholder="Team Name"
              style={styles.input}
              value={initialStateForm.teamName}
              onChange={(e) => handleFormChange("teamName", e.target.value)}
            />
          </div>

          <div style={styles.nameInputRow}>
            <label style={styles.nameTxt}>Team Nickname:</label>
            <input
              placeholder="Team Nickname"
              style={styles.input}
              value={initialStateForm.teamNickName}
              onChange={(e) => handleFormChange("teamNickName", e.target.value)}
            />
          </div>

          <div style={styles.nameInputRow}>
            <label style={styles.nameTxt}>Coach Name:</label>
            <input
              placeholder="Coach Name"
              style={styles.input}
              value={initialStateForm.coachName}
              onChange={(e) => handleFormChange("coachName", e.target.value)}
            />
          </div>

          <div style={styles.nameInputRow}>
            <label style={styles.nameTxt}>Coach Cell#:</label>
            <input
              placeholder="Coach contact number"
              style={styles.input}
              value={isFocused ? initialStateForm.coachCell : displayPhone}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              onChange={(e) => handleFormChange("coachCell", e.target.value)}
            />
          </div>

          <div style={styles.nameInputRow}>
            <label style={styles.nameTxt}>Coach Email:</label>
            <input
              placeholder="Coach email"
              style={styles.input}
              value={initialStateForm.coachEmail}
              onChange={(e) => handleFormChange("coachEmail", e.target.value)}
            />
          </div>

          <div style={styles.nameInputRow}>
            <label style={styles.nameTxt}>Game Rules:</label>
            <button onClick={toggleGroupModal} style={styles.inputButton}>
              {selectedRule
                ? selectedRule.ruleId
                : operatorTeam?.teamId?.gameRules?.ruleId ||
                  "Select game rules"}
            </button>
          </div>

          <div style={styles.nameInputRow}>
            <label style={styles.nameTxt}>Subscription:</label>
            <div style={styles.subscriptionRow}>
              <span style={styles.subscriptionText}>
                {operatorTeam?.subscriptionType?.subscriptionName}
              </span>
              <button
                disabled={loading}
                // onClick={() =>
                //   history.push('/subscriptionDetails', {
                //     state: {
                //       subscriptionId: operatorTeam?._id,
                //       teamId: operatorTeam?.teamId._id,
                //     },
                //   })
                // }
                style={styles.viewBtn}
              >
                VIEW
              </button>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={styles.rowView}>
            <button
              onClick={goBackHandler}
              style={{ ...styles.actionBtn, backgroundColor: "red" }}
            >
              CANCEL
            </button>

            <button onClick={handleUpdate} style={styles.actionBtn}>
              {updateTeamLoader ? "Saving..." : "SAVE"}
            </button>
          </div>
        </div>

        <AllRulesModal
          data={allRules || []}
          setSelectedRule={handleSelectGroup}
          groupModal={groupModal}
          closeModal={() => setGroupModal(false)}
        />

        {/* {deleteVisible && (
          <DeleteOverlay
            isVisible={deleteVisible}
            onBackdropPress={() => setDeleteVisible(false)}
            handleDelete={handleDeleteTeam}
            loading={loading}
          />
        )}

       

        {delSuccessVisible && (
          <SuccessOverlay
            onBackdropPress={() => setDelSuccessVisible(false)}
            isVisible={delSuccessVisible}
            message="Team has been deleted successfully!"
          />
        )} */}
        {successVisible && (
          <SuccessOverlay
            onBackdropPress={() => setSuccessVisible(false)}
            isVisible={successVisible}
            type="Team has been edited successfully!"
          />
        )}
      </div>
    </div>
  );
};

export default EditTeam;

const styles = {
  container: {
    position: "relative",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  content: {
    overflowY: "auto",
    padding: "50px",
  },
  backBtn: {
    padding: "10px",
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    position: "absolute",
    top: "10px",
    left: "10px",
  },
  headerTxt: {
    fontSize: "4rem",
    color: "#00008B",
    textAlign: "center",
    margin: "0",
  },
  imgHeader: {
    width: '100%',
    /* height: 200px; */
    /* background-size: cover; */
    /* background-position: center center; */
    /* position: relative; */
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '30px',
  },
  logo: {
    display: "block",
    width: "150px",
    height: "auto",
    margin: "20px auto",
  },
  deleteBtn: {
    backgroundColor: "red",
    borderRadius: '50%',
    cursor: "pointer",
    border: 'none',
    height: '40px',

  },
  racketLogo: {
    position: "fixed",
    bottom: "0",
    left: "0",
    width: "100%",
    opacity: "0.1",
    zIndex: "-1",
  },
  formContainer: {
    width: "80%",
    margin: "0 auto",
  },
  nameInputRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
    borderBottom: "1px solid #00008B",
  },
  nameTxt: {
    color: "#00008B",
    fontSize: "1em",
    flex: "0 0 150px",
    marginRight: "10px",
    fontWeight: "700",
  },
  input: {
    flex: "1",
    padding: "8px",
    fontSize: "1em",
    border: "none",
    outline: "none",
  },
  inputButton: {
    flex: "1",
    padding: "8px",
    fontSize: "1em",
    border: "none",
    backgroundColor: "transparent",
    textAlign: "left",
    cursor: "pointer",
    outline: "none",
  },
  subscriptionRow: {
    display: "flex",
    alignItems: "center",
    flex: "1",
  },
  subscriptionText: {
    flex: "1",
    fontSize: "1em",
  },
  viewBtn: {
    backgroundColor: "transparent",
    border: "1px solid #DAA520",
    padding: "5px 10px",
    borderRadius: "5px",
    color: "#DAA520",
    cursor: "pointer",
  },
  rowView: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
  },
  actionBtn: {
    margin: "0 5px",
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "#00008B",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
};
